<template>
  <div class="fan">
    <!-- 前三名 -->
    <template v-if="isInterdict">
      <Interdict></Interdict>
    </template>
    <template v-else>
      <!-- 前三名 -->
      <div class="user">
        <div class="user-item" v-for="(item, index) in fanListTop3" :key="index">
          <div class="user-info">
            <div class="user-img" :style="{
              'background-image': `url(${item?.avatarUrl || defaultUrl
                })`
            }">
            </div>
            <div class="info-box">
              <div class="rank" :data-rank="`rank-${index + 1}`">
                <div class="label-box">
                  <span class="label-shadow">NO.{{ index + 1 }}</span>
                  <span class="label-text">NO.{{ index + 1 }}</span>
                </div>
              </div>
              <div class="user-name">
                <div class="label-box">
                  <span class="label-shadow">{{ item?.nickName }}</span>
                  <span class="label-text">{{ item?.nickName }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="popularity" :data-rank="`rank-${index + 1}`">
            <i class="place"></i>
            <div class="label-box">
              <span class="label-shadow">
                {{ item?.popularity >= 10000 ? (item?.popularity / 10000).toFixed(2) + '万' : item?.popularity }}
              </span>
              <span class="label-text">
                {{ item?.popularity >= 10000 ? (item?.popularity / 10000).toFixed(2) + '万' : item?.popularity }}
              </span>
            </div>
          </div>
        </div>
      </div>


      <!-- 详情 -->
      <div class="fan-center">
        <div class="title-box">
          <div class="item title1">
            <div class="bg"></div>
            <div class="label-box">
              <span class="label-shadow">排名</span>
              <span class="label-text">排名</span>
            </div>
          </div>
          <div class="item title2">
            <div class="inner">
              <div class="bg"></div>
              <div class="label-box">
                <span class="label-shadow">粉丝昵称</span>
                <span class="label-text">粉丝昵称</span>
              </div>
            </div>
          </div>
          <div class="item title3">
            <div class="bg"></div>
            <div class="label-box">
              <span class="label-shadow">贡献值</span>
              <span class="label-text">贡献值</span>
            </div>
          </div>
        </div>
        <div class="fan-box">
          <div class="fan-center-warp" v-if="filteredList && filteredList.length > 0">
            <div class="list-items" v-for="(item, index) in filteredList" :key="index">
              <div class="first">
                <div class="label-box">
                  <span class="label-shadow">{{ index + 4 }}</span>
                  <span class="label-text">{{ index + 4 }}</span>
                </div>
              </div>
              <div class="nanu">
                <div class="avatar" :style="{ 'background-image': `url(${item?.avatarUrl || defaultUrl})` }"></div>
                <div class="name">
                  {{ item.nickName || '-' }}
                </div>
              </div>

              <div class="hot">
                {{ countShow(item?.popularity) }}
              </div>
            </div>
            <!-- <div class="placeholder"></div> -->
          </div>
        </div>
      </div>
      <!-- <userTeamRankings :userInfo="personalGifts" :useImgUrl="personalGifts.avatarUrl || defaultUrl" /> -->
    </template>
  </div>
</template>


<script>
import { mapState } from 'vuex'
import Interdict from '@/components/interdict'
import * as api from '@/service/index'
// import userTeamRankings from '@/views/ranking/userTeamRankings'

export default {
  components :{
    Interdict,
    // userTeamRankings
  },
  data() {
    return {
      defaultUrl: 'https://website.xdcdn.net/form/match/avatar/Portrait1.png',
      subSeasonID: '',
      fan: [],
      personalGifts: {}
    }
  },
  computed: {
    ...mapState(['token', 'uid', 'teamsInfo', 'seasonInfo','isInterdict']),
    fanListTop3() {
      return this.fan.filter((item, index) => index <= 2)
    },
    filteredList() {
      return this.fan.filter((item, index) => index > 2)
    }
  },
  watch: {
    seasonInfo: {
      handler(newVal) {
        if (newVal && newVal.id) {
          this.subSeasonID = newVal.id
          // 获取粉丝排名
          // 考虑到粉丝数量随时变化，所以就每次都重新调一下

          // console.log('newVal', newVal)
          // console.log('newVal1', newVal.id)
          this.fetchGiftTeamListData(this.$route.params.id)
          // let taptapavatar = this.$route.params.id
          // console.log('taptapavatar', taptapavatar)
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    countShow(hot) {
      if (hot) {
        if (hot < 10000) {
          return hot
        } else if (10000 <= hot && hot < 99999999) {
          return (((hot / 10000) * 100) / 100).toFixed(2) + '万'
        } else {
          return 9999 + '万+'
        }
      } else {
        return 0
      }
    },
    async fetchGiftTeamListData(teamID) {
      if(!this.token) return;
      try {
        const data = {
          token: this.token,
          rankType: 'season',
          teamCode: teamID
        }
        // const res = await api.getGiftTeamList(data)
        // if (res.status === 200) {
        //   this.fan = res.data
        //   // console.log('object', res)
        // }
        let res = await api.getGiftTeamDetail(data)
        // this.listData.personalGifts = res.personal
        // this.listData.personal = res.totalList
        this.personalGifts = res.data.personal
        this.fan = res.data.totalList
        let fanLength = this.fan.length;
        if(fanLength <= 3) {
          for(let i = 0; i < 3 - fanLength; i++) {
            this.fan.push({
              avatarUrl: this.defaultUrl,
              nickName: '-',
              popularity: 0
            })
          }
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/teams/detail-fan';
</style>
